<template>
  <!-- Modal template -->
  <admin-modal
    v-show="show"
    title="Remove Stream"
    :loading="loading"
    class="remove-modal"
    @cancel="closeModal"
  >
    <template v-slot:body>
      <!-- Removing stream selector -->
      <div class="modal__row">
        <div class="modal__field long-field">
          <select v-if="streams" v-model="selectedStreamId">
            <option v-for="s in streams" :key="s.id" :value="s.id">
              {{ parseStreamName(s.streamName) }}
            </option>
          </select>

          <!-- No streams placeholder -->
          <span v-else><center>No streams</center></span>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <!-- Cancel button -->
      <div class="modal-btn cancel-btn" @click="closeModal">
        Cancel
      </div>
      <!-- Submit button -->
      <div class="modal-btn remove-btn" @click="trySubmit">
        Delete
      </div>
    </template>
  </admin-modal>
</template>

<script>
import AdminModal from "@/components/admin/modals/AdminModal.vue";

// @group Dialog
// Modal for to select stream to remove
export default {
  name: "RemoveStreamModal",
  components: {
    AdminModal
  },
  props: {
    // streams list
    streams: {
      type: Array,
      default: () => []
    },
    // is modal shown
    show: {
      type: Boolean,
      default: false
    },
    // is modal loading
    loading: {
      type: Boolean,
      default: false
    },
    // stream ID of stream to remove by default
    startStreamId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      selectedStreamId: this.startStreamId
    };
  },
  computed: {
    // @vuese
    // Removing stream
    selectedStream() {
      return this.streams?.find(s => s.id == this.selectedStreamId);
    }
  },
  watch: {
    streams() {
      this.updateSelectedStream();
    },
    startStreamId() {
      this.selectedStreamId = this.startStreamId;
      this.updateSelectedStream();
    }
  },
  mounted() {
    this.updateSelectedStream();
  },
  methods: {
    // @vuese
    // Accept stream removing
    removeStream() {
      if (this.selectedStreamId) {
        /** user accepted stream removing */
        this.$emit("removeStream", { id: this.selectedStreamId });
      }
    },
    // @vuese
    // Emit 'submitted' event, if form is active
    trySubmit() {
      /** Errors and loading prevent to submit modal */
      if (!this.loading) {
        // user submitted form
        this.removeStream();
      }
    },
    // @vuese
    // Change stream when external changes occured
    updateSelectedStream() {
      if (this.selectedStream == null && this.streams?.length > 0) {
        /** if stream not set, then set first available */
        this.selectedStreamId = this.streams[0].id;
      }
    },
    // @vuese
    // Init modal closing
    closeModal() {
      /** User try to close modal */
      this.$emit("close");
    },
    // @vuese
    // Stream name without .stream
    parseStreamName(name) {
      const namePattern = /^(?<name>.+).stream$/;
      const match = namePattern.exec(name);
      if (!match) return name;
      return match.groups.name;
    }
  }
};
</script>

<style>
.modal__field.long-field {
  width: 100%;
}
.remove-modal .modal .footer .remove-btn {
  background-color: var(--light-error-color);
  color: var(--main-bg-color);
  border: none;
}
.remove-modal .modal .footer .remove-btn:hover {
  background-color: var(--error-color);
}
</style>
